export default __webpack_public_path__ + "static/media/box_gift.f46ccab9.png";